import React, { useState, useContext, SyntheticEvent } from "react";
import { useTranslation } from "react-i18next";

//MUI
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";

//Custom
import OperationsContext from "@/components/OperationsContext/OperationsContext";

//Types
import { PickerItem } from "@/@types/controls/controls";
import { AutocompleteChangeReason } from "@mui/material";
import { OperationsContextType } from "@/components/OperationsContext/OperationsContext";

const OperationsProjectPicker = () => {

  const operationsContext = useContext<OperationsContextType>(OperationsContext);

  const [isLoading, setIsLoading] = useState(false);

  const { t } = useTranslation();

  const label = "operations.select_project";
  const loadingText = "operations.loading";

  const handleChange = (evt: SyntheticEvent, value: PickerItem | null, reason: AutocompleteChangeReason) => {
    switch (reason) {
      case "createOption":
        break;
      case "selectOption":
        applyChange(value);
        break;
      case "removeOption":
        break;
      case "clear":
        applyChange(null);
        break;
      case "blur":
        break;
    }
  };

  const applyChange = (option: PickerItem | null) => {
    if (option) {
      operationsContext.selectProject(option.value as number);
    } else {
      operationsContext.selectProject(null);
    }
  };



  const p = operationsContext.selectedProject;
  const selectedItem = p ? { value: p.id, label: p.naziv} as PickerItem : null;
  const customStyle = selectedItem === null ? { backgroundColor: "#f00" } : {};

  return (
    <Autocomplete
      disablePortal
      size="small"
      options={operationsContext.projectItems}
      value={selectedItem}
      getOptionLabel={(option: PickerItem) => `${option.label}`}
      autoHighlight={true}
      isOptionEqualToValue={(option: PickerItem, value: PickerItem) => option.value == value.value}
      renderInput={(params) => {
        return (
          <TextField 
            {...params}
            placeholder={t(label)}
            variant="outlined"
            required={false}
            label={undefined}
            sx={{ width: 300 }} 
            InputProps={{
              sx: {
                color: "#FFF",
                ...customStyle
              },
              ...params.InputProps
            }}
            />

        )
      }
      }
      onChange={handleChange}
      loading={isLoading}
      loadingText={t(loadingText)}
    />
  )
}

export default OperationsProjectPicker;